const isL1RevampEnabled = ({ globalInfo, globalInfoDataAvailable }) => {
  if (globalInfoDataAvailable) {
    return globalInfo && globalInfo.enable_oyo360_l1_revamp ? true : false
  }
  return false;
}

export default isL1RevampEnabled;
